import React from 'react';

import CreateEditPersonnelFormUI from '../CreateEditPersonnelFormUI';
import { personnelStatus } from '../../constants';
import DuplicatePersonnelNameValidation from '../../mappers/duplicatePersonnelNameValidation';

const CreatePersonnelDialog = (props) => {
  const {
    openDialog,
    openCreatePersonnelDialog,
    onHandleInputChange,
    personnel,
    submitPersonnel,
    isSaving,
    sites,
    branch,
    personnels,
    changeValidationState,
    validationState,
    isShort
  } = props;

  const handleSubmit = (e) => {
    e.preventDefault();
    const { personnel } = props;

    if (DuplicatePersonnelNameValidation(personnels, personnel)) {

      let personnelTypeValue = isShort ? 2 : 1;

      const payload = {
        ...personnel,
        statusId: personnelStatus.ACTIVE,
        branchId: branch.id,
        isShort: isShort,
        personnelTypeId : personnelTypeValue
      };


      changeValidationState(true);
      submitPersonnel(payload);
    } else {
      changeValidationState(false);
    }
  };

  return (
    <CreateEditPersonnelFormUI
      openDialog={openDialog}
      openCreatePersonnelDialog={openCreatePersonnelDialog}
      onHandleInputChange={onHandleInputChange}
      personnel={personnel}
      isSaving={isSaving}
      handleSubmit={handleSubmit}
      sites={sites}
      title="Create New Personnel"
      validationState={validationState}
      isShort={isShort}
    />
  );
};

export default CreatePersonnelDialog;
